<template>
    <div>
       <div style="font-size: 35px;font-weight: bold;text-align: center">评价申请结果</div>
      <el-form  class="demo-ruleForm"  :model="form1"   ref="form1" style="min-height: 700px;width: 500px;margin: 0 auto;font-size: 18px">
        <div  class="gradeX" >
          <el-divider></el-divider>
          <div class="ename" style="font-size: 22px;font-weight: bold;margin-top: 10px">公司名称:{{form1.ename}}</div>
          <el-divider></el-divider>
          <div class="">统一社会信用代码:{{form1.ecode}}</div>
          <el-divider></el-divider>
          <div class="">联系人:{{form1.contacts}}</div>
          <el-divider></el-divider>
          <div class="">法定代表人:{{form1.jperson}}</div>
          <el-divider></el-divider>
          <div class="">联系电话:{{form1.tel}}</div>
          <el-divider></el-divider>
          <div class="">地址:{{form1.eaddr}}</div>
          <el-divider></el-divider>
          <div class="">企业英文名:{{form1.enterprise}}</div>
          <el-divider></el-divider>
          <div class="">企业网址:{{form1.website}}</div>
          <el-divider></el-divider>
          <div class="">企业联系邮箱:{{form1.email}}</div>
          <el-divider></el-divider>
          <div class="">企业介绍:{{form1.introduce}}</div>
          <el-divider></el-divider>
          <div class="">成立时间:{{form1.foundtime}}</div>
          <el-divider></el-divider>
          <div class="">目前员工数:{{form1.staff}}</div>
          <el-divider></el-divider>
          <div class="">所属行业:{{form1.industry}}</div>
          <el-divider></el-divider>
          <div class="">企业优势:{{form1.advantage}}</div>
          <el-divider></el-divider>
          <div class="">企业所有制:{{form1.classify}}</div>
          <el-divider></el-divider>
          <div class="">状态:
            <label v-if="form1.state =='1'" style="color: green;">受理中</label>
            <label v-if="form1.state =='0'" style="color: blue">待受理</label>
            <label v-if="form1.state =='2'" style="color: red">完成</label>
          </div>
        </div>
        <el-divider></el-divider>
         </el-form>

    </div>

</template>

<script>
import rootPathssb from '@/api/mainApi'
import { dataGetUrl } from '@/api/index'
export default {
  name: 'enterquery',
  data () {
    return {
      showHeader: false,
      form1: {
        ename: '',
        ecode: '',
        jperson: '',
        tel: '',
        createTime: '',
        updateTime: '',
        contacts: '',
        indSubname: '',
        provName: '',
        cityName: '',
        state: '',
        eAddr: '',
        enterprise: '',
        website: '',
        email: '',
        introduce: '',
        foundtime: '',
        staff: '',
        industry: '',
        advantage: '',
        classify: ''
      },
      tableData: [],
      pid: ''
    }
  },
  created () {
    var that = this
    that.form1.id = that.$route.query.pid
    // 获取父页面Pid的值

    /* 获取父页面参数 */
    /* 后台申请默认值 */
    dataGetUrl(rootPathssb.rootPath + '/user/app/finds').then(function (response) {
      console.log(response)
      if (response.data.result === 1) {
        for (var i = 0; i < response.data.info.length; i++) {
          // 遍历返回值数组长度
          // eslint-disable-next-line camelcase
          var cur_person = response.data.info[i]
          // 遍历赋值
          console.log(cur_person.id)
          if (cur_person.id === that.form1.id) {
            // 判断新赋值id和父页面id做等于判断
            that.form1 = response.data.info[i]
            // 取值返回值长度第i个符合条件
            console.log(123124)
          }
        }
      };

      console.log(response.data.info)
    }).catch(function (error) {
      console.log(error); console.log('aaa')
    })
  }
}
</script>

<style scoped>
  .gradeX div{
    margin-top: 5px;
    margin-bottom: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/components/enterprise/enterquery.vue